import { Route, Routes } from "react-router";
import VideoList from "./VideoList";
import UploadVideo from "./UploadVideo";
import VideoEdit from "./VideoEdit";
import VideoEmbed from "./VideoEmbed";

function VideosRoutes() {
  return (
    <Routes>
      <Route path="" element={<VideoList />} />
      <Route path="upload" element={<UploadVideo />} />
      <Route path=":video">
        <Route path="" element={<VideoEdit />} />
        <Route path="embed" element={<VideoEmbed />} />
      </Route>
    </Routes>
  );
}

export default VideosRoutes;
